import { DASHBOARD_PERIOD_LABELS } from "../constants/dashboardPeriods";
import { DashboardPeriodPreset, IVisitPeriod } from "../types/ownerDashboard.types";

export function getDashboardPeriodLabel(
  preset: DashboardPeriodPreset | undefined,
  period?: IVisitPeriod | null
): string {
  if (preset) {
    return DASHBOARD_PERIOD_LABELS[preset].toLowerCase();
  }

  if (period?.initial_date && period?.final_date) {
    return `${period.initial_date} – ${period.final_date}`;
  }

  return "período selecionado";
}
